import { ApiError } from '@/shared/api'

export type JoinErrorKind = 'ended' | 'cancelled' | 'full' | 'not-found' | 'unknown'

export interface JoinErrorInfo {
  kind: JoinErrorKind
  message: string
}

// Машиночитаемый code бэка (problem+json) → понятное объяснение отказа входа.
// Терминальные kind (ended/cancelled/not-found) страницы показывают полноэкранным
// статусом, остальные — тостом.
export function joinErrorInfo(error: unknown): JoinErrorInfo {
  if (error instanceof ApiError) {
    switch (error.code?.toUpperCase()) {
      case 'MEETING_ENDED':
        return { kind: 'ended', message: 'Встреча уже завершена.' }
      case 'MEETING_CANCELLED':
        return { kind: 'cancelled', message: 'Встреча отменена организатором.' }
      case 'MEETING_FULL':
        return { kind: 'full', message: 'Встреча заполнена: достигнут лимит участников.' }
      case 'MEETING_NOT_FOUND':
        return { kind: 'not-found', message: 'Встреча не найдена. Проверьте ссылку.' }
      default:
        return { kind: 'unknown', message: 'Не удалось войти во встречу. Попробуйте ещё раз.' }
    }
  }
  return {
    kind: 'unknown',
    message: 'Не удалось связаться с сервером. Проверьте соединение и попробуйте ещё раз.',
  }
}
